/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBillingDetails200ResponseIban
 */
export interface GetBillingDetails200ResponseIban {
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200ResponseIban
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200ResponseIban
     */
    number: string;
}

/**
 * Check if a given object implements the GetBillingDetails200ResponseIban interface.
 */
export function instanceOfGetBillingDetails200ResponseIban(value: object): value is GetBillingDetails200ResponseIban {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function GetBillingDetails200ResponseIbanFromJSON(json: any): GetBillingDetails200ResponseIban {
    return GetBillingDetails200ResponseIbanFromJSONTyped(json, false);
}

export function GetBillingDetails200ResponseIbanFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingDetails200ResponseIban {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'number': json['number'],
    };
}

export function GetBillingDetails200ResponseIbanToJSON(json: any): GetBillingDetails200ResponseIban {
    return GetBillingDetails200ResponseIbanToJSONTyped(json, false);
}

export function GetBillingDetails200ResponseIbanToJSONTyped(value?: GetBillingDetails200ResponseIban | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'number': value['number'],
    };
}

